import * as uiAudio from './ui-audio';
import * as questionAudio from './question-audio';

function reloadStudentSyllabusPage() {
    try {
        window.opener.location.reload();
    } catch(error) {}
}

export function initializeMultiPageTest() {
    if (document.querySelector('.questions')) {
        const progressBar = document.querySelector('.progress-bar');
        const totalQuestions = parseInt(progressBar.getAttribute('aria-valuemax'));
        const correctFeedbackAlert = document.querySelector('#correct-feedback');
        const incorrectFeedbackAlert = document.querySelector('#incorrect-feedback');
        const errorFeedbackAlert = document.querySelector('#error-feedback');
        const answers = Array.from(document.querySelectorAll('form.questions input[data-answer-id]'));
        const answerButton = document.querySelector('.answer-button');
        const answerButtonContent = answerButton.querySelector('.content');
        const answerButtonSpinner = answerButton.querySelector('.checking');

        uiAudio.updateAnswerButtonAudio(answerButtonContent);
        questionAudio.updateAudioToggleButtonVisibility();

        answers.forEach(answer => answer.addEventListener('change', handleAnswerChange));
        function handleAnswerChange(event) {
            if (answerButton.classList.contains('disable-on-last')) return;

            answerButton.disabled = false;
            answerButtonContent.innerHTML = translate('Check Answer');
            answerButtonContent.dataset.buttonText = 'Check Answer';
            uiAudio.updateAnswerButtonAudio(answerButtonContent);
        }

        answerButton.addEventListener('click', handleAnswerButtonClick);
        async function handleAnswerButtonClick() {
            const currentQuestion = document.querySelector('.question.current');
            const nextQuestion = document.querySelector('.question.current + .question');

            switch (answerButtonContent.dataset.buttonText) {
                case 'Next Question':
                    updateDisplayedQuestion();
                    updateProgressBar();
                    updateAnswerButton();
                    resetFeedback();
                    questionAudio.resetAudioForNextQuestion();
                    break;
                case 'Check Answer':
                    await checkAnswer();
                    break;
                case 'Submit Quiz':
                    answers.forEach(answer => answer.disabled = false);
                    document.querySelector('form.questions').submit();
                    answerButton.disabled = true;
                    answerButtonSpinner.classList.add('spinner-border');
                    break;
            }

            function updateDisplayedQuestion() {
                if (nextQuestion) {
                    currentQuestion.classList.remove('current');
                    nextQuestion.classList.add('current');
                }
            }

            function updateProgressBar() {
                const nextQuestionNumber = nextQuestion.dataset.questionNumber;

                progressBar.setAttribute('aria-valuenow', `${nextQuestionNumber}`);
                progressBar.innerText = `${nextQuestionNumber} of ${totalQuestions}`;

                if (nextQuestionNumber && totalQuestions) {
                    const barLength = (
                        nextQuestionNumber / totalQuestions
                    ) * 100;
                    progressBar.style.width = `${barLength}%`;
                }
            }

            function updateAnswerButton() {
                if (nextQuestion.classList.contains('last')) {
                    if (answerButton.classList.contains('disable-on-last')) {
                        answerButton.classList.add('d-none');
                        return;
                    }

                    if (!answerButton.dataset.forStudent) {
                        answerButtonContent.innerHTML = translate('Submit Quiz');
                        answerButtonContent.dataset.buttonText = 'Submit Quiz';
                    }
                }

                if (answerButton.dataset.forStudent) {
                    answerButton.disabled = true;
                    answerButtonContent.innerHTML = translate('Check Answer');
                    answerButtonContent.dataset.buttonText = 'Check Answer';
                }

                uiAudio.updateAnswerButtonAudio(answerButtonContent);
            }

            function resetFeedback() {
                correctFeedbackAlert.classList.add('hidden');
                incorrectFeedbackAlert.classList.add('hidden');
                errorFeedbackAlert.classList.add('hidden');
            }

            async function checkAnswer() {
                const questionId = currentQuestion.dataset.questionId;
                const selectedAnswer = currentQuestion.querySelector('.answers input:checked').value;

                const allResponses = [...document.querySelectorAll('.answers input:checked')]
                    .map(answer => ({
                        questionId: answer.closest('.question').dataset.questionId,
                        answerId: answer.value
                    }));

                disableUi();
                try {
                    const isCorrect = await fetchIsCorrect(questionId, selectedAnswer, allResponses);
                    if (isCorrect) {
                        showFeedback(correctFeedbackAlert);
                    } else {
                        showFeedback(incorrectFeedbackAlert);
                    }
                    updateUi();
                } catch (ex) {
                    showFeedback(errorFeedbackAlert);
                    enableUi();
                }
            }

            function disableUi() {
                answerButton.disabled = true;
                answerButtonSpinner.classList.add('spinner-border');
                answerButtonContent.innerHTML = translate('Checking') + '&hellip;';
                currentQuestion.querySelectorAll('input').forEach(input => input.disabled = true);
            }

            function enableUi() {
                answerButton.disabled = false;
                answerButtonSpinner.classList.remove('spinner-border');
                answerButtonContent.innerHTML = translate('Check Answer');
                answerButtonContent.dataset.buttonText = 'Check Answer';
                uiAudio.updateAnswerButtonAudio(answerButtonContent);
            }

            function updateUi() {
                answerButton.disabled = false;
                answerButtonSpinner.classList.remove('spinner-border');

                if (currentQuestion.classList.contains('last')) {
                    answerButtonContent.innerHTML = translate('Submit Quiz');
                    answerButtonContent.dataset.buttonText = 'Submit Quiz';
                    uiAudio.updateAnswerButtonAudio(answerButtonContent);
                    return;
                }

                answerButtonContent.innerHTML = translate('Next Question');
                answerButtonContent.dataset.buttonText = 'Next Question';
                uiAudio.updateAnswerButtonAudio(answerButtonContent);
            }

            async function fetchIsCorrect(questionId, answerId, allResponses) {
                const response = await axios.post(checkAnswerUrl, {
                    questionId,
                    answerId,
                    allResponses
                });
                return response.data.isCorrect;
            }

            function showFeedback(feedbackElement) {
                feedbackElement.classList.remove('hidden');
                if (questionAudio.activated) {
                    questionAudio.setupFeedbackAudioElement(feedbackElement);
                    questionAudio.resetAudioPlayback();

                    if (questionAudio.feedbackAudioAutoplay) {
                        questionAudio.playAudio();
                    }
                }
            }
        }

        function translate(key) {
            if (resourceLanguage === 'en') {
                return key;
            }

            return  translations[key] ? translations[key] : key;
        }
    }
}

export function initializeMultiPageTestResults() {
    if (document.getElementById('score')) {
        reloadStudentSyllabusPage();
    }
}

export function quizMeButton() {
    const quizMeForm = document.getElementById('quiz-me-form');

    if (quizMeForm) {
        reloadStudentSyllabusPage();
        const quizMeButton = quizMeForm.querySelector('button[type="submit"]');

        quizMeForm.addEventListener('submit', (event) => {
            quizMeButton.disabled = true;
            quizMeButton.querySelector('span').classList.add('spinner-border');
        });
    }
}
